/* Theme-local navigation; Shopify's native product and cart code handles commerce. */
document.addEventListener('click', (event) => {
  document.querySelectorAll('.al-mobile-menu[open], .al-mega[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.al-mobile-menu[open], .al-mega[open]').forEach((menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});

/* ALÉTHOS — BestTrack interface language. Carrier events and shipment data stay intact. */
(() => {
  if (!/^\/apps\/bestrack\/?$/.test(window.location.pathname)) return;
  const translations = new Map(Object.entries({
    'Tracking Number': 'Numéro de suivi',
    'Tracking number': 'Numéro de suivi',
    'Order Number': 'Numéro de commande',
    'Order number': 'Numéro de commande',
    'Email': 'E-mail',
    'Track Your Order': 'Suivre ma commande',
    'Powered by BestTrack': 'Suivi assuré par BestTrack',
    'Ready-to-go tracking query': 'Rechercher une commande',
    'Tracking method': 'Méthode de recherche',
    'Shipment progress': 'Suivi du colis',
    'Delivery progress': 'Étapes de livraison',
    'Tracking:': 'Suivi :',
    'Ordered': 'Commande confirmée',
    'Order Ready': 'Commande préparée',
    'In Transit': 'En transit',
    'In transit': 'En transit',
    'Out for Delivery': 'En cours de livraison',
    'Delivered': 'Livré',
    'Est. Delivery': 'Livraison estimée',
    'Estimated time may update as tracking progresses.': 'Cette estimation peut évoluer au fil de l’acheminement.',
    'Shipping Details': 'Détails de l’acheminement',
    'Shipping events': 'Historique du colis',
    'Package Contents': 'Contenu du colis',
    'Carrier': 'Transporteur',
    'You may also like...': 'Vous aimerez aussi…',
    'Recommended products carousel': 'Sélection de bijoux',
    'Previous': 'Précédent',
    'Next': 'Suivant'
  }));
  const sources = new WeakMap();
  let language = 'fr';
  try { language = sessionStorage.getItem('al-besttrack-language') === 'en' ? 'en' : 'fr'; } catch (_) {}

  function french(value) {
    const text = value.trim();
    let result = translations.get(text);
    if (!result) {
      const step = text.match(/^(Ordered|Order Ready|In Transit|Out for Delivery|Delivered) (complete|current|upcoming)$/);
      if (step) result = translations.get(step[1]) + ' — ' + ({complete: 'terminé', current: 'étape actuelle', upcoming: 'à venir'})[step[2]];
    }
    if (!result) return value;
    return value.replace(text, result);
  }

  // Retain each node's original copy so English can be restored without a reload.
  function localize(owner, key, current) {
    let values = sources.get(owner);
    if (!values) { values = new Map(); sources.set(owner, values); }
    let entry = values.get(key);
    if (!entry || (current !== entry.source && current !== entry.french)) {
      entry = {source: current, french: french(current)};
      values.set(key, entry);
    }
    return language === 'fr' ? entry.french : entry.source;
  }

  function mount() {
    const root = document.getElementById('besttrack-tracking-page-root');
    if (!root || document.getElementById('al-besttrack-language')) return Boolean(root);
    const bar = document.createElement('div');
    bar.id = 'al-besttrack-language';
    bar.style.cssText = 'max-width:1200px;margin:0 auto;padding:18px 24px 0;display:flex;align-items:center;justify-content:flex-end;gap:10px;color:#1b211f;font-size:13px;';
    const label = document.createElement('label');
    label.htmlFor = 'al-besttrack-language-select';
    label.textContent = 'Langue / Language';
    const select = document.createElement('select');
    select.id = 'al-besttrack-language-select';
    select.style.cssText = 'font:inherit;color:inherit;background:#f7f4ee;border:1px solid #b5a17a;border-radius:4px;padding:8px 30px 8px 10px;min-height:40px;';
    [['fr', 'Français'], ['en', 'English']].forEach(([value, text]) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = text;
      select.appendChild(option);
    });
    select.value = language;
    bar.append(label, select);
    root.before(bar);
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => { scheduled = false; apply(); });
    });
    function apply() {
      observer.disconnect();
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script,style,textarea,[contenteditable="true"]')) continue;
        const next = localize(node, 'text', node.nodeValue);
        if (next !== node.nodeValue) node.nodeValue = next;
      }
      root.querySelectorAll('[aria-label],[placeholder],[title]').forEach((element) => {
        ['aria-label', 'placeholder', 'title'].forEach((attribute) => {
          const current = element.getAttribute(attribute);
          if (current === null) return;
          const next = localize(element, attribute, current);
          if (next !== current) element.setAttribute(attribute, next);
        });
      });
      const main = root.querySelector('main');
      if (main) main.lang = language;
      observer.observe(root, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'placeholder', 'title']});
    }
    select.addEventListener('change', () => {
      language = select.value === 'en' ? 'en' : 'fr';
      try { sessionStorage.setItem('al-besttrack-language', language); } catch (_) {}
      apply();
    });
    apply();
    return true;
  }
  function start() {
    if (mount()) return;
    const ready = new MutationObserver(() => { if (mount()) ready.disconnect(); });
    ready.observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
